import * as ROUTES from 'src/shared/constants/routes';

export const REGVERS_ADMIN = [
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.COMPANIES,
    iconLabel: 'icon-company',
    submenuname: 'entities'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.ADMIN_REGULATION,
    iconLabel: 'icon-regulation-newer',
    submenuname: 'Regulations'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.SETTING,
    iconLabel: 'icon-settings',
    submenuname: 'Settings'
  }
];

export const PARTNER_ADMIN = [
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.COMPANIES,
    iconLabel: 'icon-company',
    submenuname: 'companies'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.SETTING,
    iconLabel: 'icon-settings',
    submenuname: 'Settings'
  }
];

export const PRIMARY_ADMIN = [
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.DASHBOARD,
    iconLabel: 'icon-ic_dashboard',
    submenuname: 'Dashboard'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.REGULATION,
    iconLabel: 'icon-regulation-newer',
    submenuname: 'Regulations'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.FINES,
    iconLabel: 'icon-ic_fines',
    submenuname: 'Fines'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.TASKS,
    iconLabel: 'icon-task-menu',
    submenuname: 'Tasks'
  },

  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.AVERY_AI,
    iconLabel: 'icon-averyAI',
    submenuname: 'SurgeONE Co-Pilot'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.REPORTS,
    iconLabel: 'icon-reports',
    submenuname: 'Reports'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.NEWS,
    iconLabel: 'icon-ic_news',
    submenuname: 'News'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.USERS,
    iconLabel: 'icon-users',
    submenuname: 'Users'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.MY_DOCS,
    iconLabel: 'icon-ic_my-doc',
    submenuname: 'My Docs'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.FUSIONONE,
    iconLabel: 'icon-share',
    submenuname: 'Fusion1'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.SETTING,
    iconLabel: 'icon-settings',
    submenuname: 'Settings'
  }
];

export const SECONDARY_ADMIN = [
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.DASHBOARD,
    iconLabel: 'icon-ic_dashboard',
    submenuname: 'Dashboard'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.REGULATION,
    iconLabel: 'icon-regulation-newer',
    submenuname: 'Regulations'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.FINES,
    iconLabel: 'icon-ic_fines',
    submenuname: 'Fines'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.TASKS,
    iconLabel: 'icon-task-menu',
    submenuname: 'Tasks'
  },

  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.AVERY_AI,
    iconLabel: 'icon-averyAI',
    submenuname: 'SurgeONE Co-Pilot'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.REPORTS,
    iconLabel: 'icon-reports',
    submenuname: 'Reports'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.NEWS,
    iconLabel: 'icon-ic_news',
    submenuname: 'News'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.USERS,
    iconLabel: 'icon-users',
    submenuname: 'Users'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.MY_DOCS,
    iconLabel: 'icon-ic_my-doc',
    submenuname: 'My Docs'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.FUSIONONE,
    iconLabel: 'icon-share',
    submenuname: 'Fusion1'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.SETTING,
    iconLabel: 'icon-settings',
    submenuname: 'Settings'
  }
];

export const USER = [
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.DASHBOARD,
    iconLabel: 'icon-ic_dashboard',
    submenuname: 'Dashboard'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.REGULATION,
    iconLabel: 'icon-regulation-newer',
    submenuname: 'Regulations'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.FINES,
    iconLabel: 'icon-ic_fines',
    submenuname: 'Fines'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.TASKS,
    iconLabel: 'icon-task-menu',
    submenuname: 'Tasks'
  },

  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.AVERY_AI,
    iconLabel: 'icon-averyAI',
    submenuname: 'SurgeONE Co-Pilot'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.REPORTS,
    iconLabel: 'icon-reports',
    submenuname: 'Reports'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.NEWS,
    iconLabel: 'icon-ic_news',
    submenuname: 'News'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.USERS,
    iconLabel: 'icon-users',
    submenuname: 'Users'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.MY_DOCS,
    iconLabel: 'icon-ic_my-doc',
    submenuname: 'My Docs'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.FUSIONONE,
    iconLabel: 'icon-share',
    submenuname: 'Fusion1'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.SETTING,
    iconLabel: 'icon-settings',
    submenuname: 'Settings'
  }
];

export const REGVERS_ADMIN_LOGIN_AS = [
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.DASHBOARD,
    iconLabel: 'icon-ic_dashboard',
    submenuname: 'Dashboard'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.REGULATION,
    iconLabel: 'icon-regulation-newer',
    submenuname: 'Regulations'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.FINES,
    iconLabel: 'icon-ic_fines',
    submenuname: 'Fines'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.TASKS,
    iconLabel: 'icon-task-menu',
    submenuname: 'Tasks'
  },

  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.AVERY_AI,
    iconLabel: 'icon-averyAI',
    submenuname: 'SurgeONE Co-Pilot'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.REPORTS,
    iconLabel: 'icon-reports',
    submenuname: 'Reports'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.NEWS,
    iconLabel: 'icon-ic_news',
    submenuname: 'News'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.USERS,
    iconLabel: 'icon-users',
    submenuname: 'Users'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.MY_DOCS,
    iconLabel: 'icon-ic_my-doc',
    submenuname: 'My Docs'
  },
  {
    pathname: ROUTES.BASEPATH,
    subpathname: ROUTES.SETTING,
    iconLabel: 'icon-settings',
    submenuname: 'Settings'
  }
];